import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue'

import lottie from 'lottie-web'
import lottieFlow from '@/assets/lottieFlow.json'


export default /*@__PURE__*/_defineComponent({
  __name: 'LottieFlow',
  props: {
  width: {
    type: String,
    default: '50px'
  },
  height: {
    type: String,
    default: '50px'
  },
  padding: {
    type: String,
    default: '0px'
  },
  autoplay: {
    type: Boolean,
    default: true
  },
  loop: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props
const animation = ref(null)

onMounted(() => {
  if (animation.value) {
    lottie.loadAnimation({
      container: animation.value,
      renderer: 'svg',
      loop: props.loop,
      autoplay: props.autoplay,
      animationData: lottieFlow
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "animation",
    ref: animation,
    style: _normalizeStyle({ padding: __props.padding, width: __props.width, height: __props.height })
  }, null, 4))
}
}

})